import { Link, useLocation } from "react-router"
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import clsx from "clsx"
import { NAV_GROUPS } from "./nav"

export function AppSidebar() {
  const location = useLocation()
  return (
    <Sidebar>
      <SidebarHeader>
        <div className="rounded-md px-2 py-1">
          <div className="text-sm font-semibold text-foreground">
            训练管理后台
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        {NAV_GROUPS.map((group) => (
          <SidebarGroup key={group.label}>
            <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu className="space-y-1">
                {group.items.map((item) => {
                  const isActive =
                    location.pathname === item.url ||
                    location.pathname.startsWith(`${item.url}/`)
                  return (
                    <SidebarMenuItem key={item.title}>
                      <SidebarMenuButton
                        asChild
                        isActive={isActive}
                        className={clsx(
                          "group/menu-button relative transition-all duration-200",
                          {
                            "bg-primary/10 text-primary font-medium shadow-sm":
                              isActive,
                            "hover:bg-accent/50": !isActive,
                          }
                        )}
                      >
                        <Link
                          to={item.url}
                          className={clsx(
                            "flex items-center gap-3 rounded-lg px-3 py-2.5",
                            "transition-colors duration-200",
                            {
                              "text-primary": isActive,
                              "text-foreground/70 hover:text-foreground":
                                !isActive,
                            }
                          )}
                        >
                          <item.icon
                            className={clsx("h-5 w-5 transition-colors", {
                              "text-primary": isActive,
                              "text-muted-foreground group-hover/menu-button:text-foreground":
                                !isActive,
                            })}
                          />
                          <span className="font-medium">{item.title}</span>
                          {isActive && (
                            <span className="absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 rounded-r-full bg-primary" />
                          )}
                        </Link>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  )
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  )
}
